var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconHide = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2.237 13.625 11.72-11.25M6.124 12.406c.607.19 1.24.284 1.875.281 2.562.044 5.162-1.756 6.762-3.524a1.03 1.03 0 0 0 0-1.388 12.5 12.5 0 0 0-1.918-1.725M11.18 5.044A7.1 7.1 0 0 0 8 4.25c-2.5-.044-5.125 1.719-6.763 3.525a1.03 1.03 0 0 0 0 1.387 12.5 12.5 0 0 0 3.082 2.5M6.125 9.92a2.406 2.406 0 0 1 3.437-3.3m.782 1.85A2.343 2.343 0 0 1 8 10.812"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2.237 13.625 11.72-11.25M6.124 12.406c.607.19 1.24.284 1.875.281 2.562.044 5.162-1.756 6.762-3.524a1.03 1.03 0 0 0 0-1.388 12.5 12.5 0 0 0-1.918-1.725M11.18 5.044A7.1 7.1 0 0 0 8 4.25c-2.5-.044-5.125 1.719-6.763 3.525a1.03 1.03 0 0 0 0 1.387 12.5 12.5 0 0 0 3.082 2.5M6.125 9.92a2.406 2.406 0 0 1 3.437-3.3m.782 1.85A2.343 2.343 0 0 1 8 10.812"
  }));
});
export default SvgIconHide;
export const raw = __webpack_public_path__ + "static/media/IconHide.2efea607b8cd96c4dbd208f91c8f99ca.svg";